import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from "recharts";

const PERIODS = [
  { key: "day", label: "Jour" },
  { key: "week", label: "Semaine" },
  { key: "month", label: "Mois" },
];

export default function HistoryCharts({ sites = [], types = [] }) {
  const [period, setPeriod] = useState("day");
  const [site, setSite] = useState("all");
  const [ptype, setPtype] = useState("all");

  const params = new URLSearchParams({ period });
  if (site !== "all") params.set("site", site);
  if (ptype !== "all") params.set("packaging_type", ptype);

  const { data = [] } = useQuery({
    queryKey: ["history", period, site, ptype],
    queryFn: async () => (await api.get(`/history?${params.toString()}`)).data,
  });

  return (
    <div className="rounded-xl border-2 border-slate-300 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between mb-3 gap-3 flex-wrap">
        <h3 className="font-display font-bold text-lg text-slate-900">Historique des mouvements</h3>
        <div className="grid grid-cols-3 gap-1 bg-slate-200 p-1 rounded-xl">
          {PERIODS.map((p) => (
            <button
              key={p.key}
              onClick={() => setPeriod(p.key)}
              data-testid={`period-filter-${p.key}`}
              className={`tactile px-4 py-1.5 rounded-lg text-sm font-bold ${
                period === p.key ? "bg-white text-slate-900 shadow" : "text-slate-600"
              }`}
            >
              {p.label}
            </button>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 mb-4">
        <Select value={site} onValueChange={setSite}>
          <SelectTrigger className="h-11" data-testid="history-site-filter"><SelectValue placeholder="Site" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les sites</SelectItem>
            {sites.map((s) => <SelectItem key={s.code} value={s.code}>{s.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={ptype} onValueChange={setPtype}>
          <SelectTrigger className="h-11" data-testid="history-type-filter"><SelectValue placeholder="Type" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tous les types</SelectItem>
            {types.map((t) => <SelectItem key={t.code} value={t.code}>{t.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div style={{ width: "100%", height: 280 }}>
        <ResponsiveContainer>
          <BarChart data={data} margin={{ top: 5, right: 5, left: -15, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="envois" name="Envois (piles)" fill="#B45309" radius={[3, 3, 0, 0]} />
            <Bar dataKey="lavages" name="Lavés (piles)" fill="#15803D" radius={[3, 3, 0, 0]} />
            <Bar dataKey="receptions" name="Réceptions (piles)" fill="#1E3A8A" radius={[3, 3, 0, 0]} />
            <Bar dataKey="pertes" name="Casses (unités)" fill="#DC2626" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
